module.exports = __webpack_public_path__ + "static/img/PC-1.28d5e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-1.png
// module id = 92Rw
// module chunks = 0